<template>
  <div>
    <v-form ref="loginform" :disabled="facebookLoginLoading" spellcheck="false">
      <v-row justify="center">
        <v-col lg="8">
          <v-text-field
            v-model="email"
            validate-on-blur
            type="email"
            :label="this.$t('label.email')"
            :rules="emailRules"
          ></v-text-field>
          <v-text-field
            v-model="password"
            type="password"
            :label="this.$t('label.password')"
            :rules="passwordRules"
          ></v-text-field>
          <v-btn
            class="font-weight-bold no-text-transform mb-3"
            style="width: 100%"
            color="primary"
            type="submit"
            @click="login"
            :disabled="facebookLoginLoading"
            :loading="loading"
            >{{ this.$t("button.login") }}
          </v-btn>
          <hr
            v-if="$store.state.config.template_settings.login_with_facebook"
          />
          <v-btn
            v-if="$store.state.config.template_settings.login_with_facebook"
            class="fb-signin-button no-text-transform mt-3"
            style="width: 100%"
            @click="facebookLogin"
            :loading="facebookLoginLoading"
          >
            <div class="white--text font-weight-bold">
              <v-icon>mdi-facebook</v-icon>

              {{ this.$t("button.login_with_facebook") }}
            </div>
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col lg="8" align="center">
          <a @click="goToRequestPassword">{{
            this.$t("button.reset_password")
          }}</a>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <span>
            Heeft u nog geen account?
            <a @click="goToRegister">{{ this.$t("button.register") }}</a>
          </span>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { login } from "@/mixins/login";
export default {
  name: "Form",
  mixins: [login]
};
</script>

<style scoped>
.fb-signin-button {
  border-radius: 3px;
  background-color: #4267b2 !important;
}
</style>
